import React from "react";
import Navbar from "../header";
import Footer from "../footer";

const TermsAndConditions = () => {
  return (
    <>

    <Navbar   menuColor="red" />

    <div  style={{marginTop:"60px" }}></div>

    <div className="container-fluid bg-light py-5">
      <div className="container">
        {/* Header */}
        <div className="text-center mb-5">
          <h1 className="fw-bold text-primary">Terms & Conditions</h1>
          <p className="text-muted mt-2">
            Please read these terms carefully before using our doctor consultation platform.
          </p>
        </div>

        {/* Card */}
        <div className="card shadow-lg border-0 rounded-4">
          <div className="card-body p-4 p-md-5">

            {/* Section */}
            <section className="mb-4">
              <h4 className="fw-semibold text-dark">1. Acceptance of Terms</h4>
              <p className="text-muted">
                By accessing or using this website, you agree to be bound by these
                Terms and Conditions, our Privacy Policy, and all applicable laws
                and regulations. If you do not agree with any part of these terms,
                you must not use this platform.
              </p>
            </section>

            <section className="mb-4">
              <h4 className="fw-semibold text-dark">2. Nature of Medical Services</h4>
              <p className="text-muted">
                This platform provides online medical consultation services that
                allow users to communicate with licensed medical professionals.
                Online consultations do not replace physical examinations or
                emergency medical care.
              </p>
              <p className="text-muted">
                If you believe you are experiencing a medical emergency, you must
                seek immediate in-person medical attention.
              </p>
            </section>

            <section className="mb-4">
              <h4 className="fw-semibold text-dark">3. User Eligibility</h4>
              <p className="text-muted">
                You must be legally capable of entering into a binding agreement
                to use this platform. By using this service, you confirm that all
                information provided is accurate, complete, and truthful.
              </p>
            </section>

            <section className="mb-4">
              <h4 className="fw-semibold text-dark">4. User Responsibilities</h4>
              <ul className="text-muted">
                <li>Provide accurate medical history and personal details</li>
                <li>Respect medical professionals and platform staff</li>
                <li>Not misuse, abuse, or attempt to manipulate the platform</li>
                <li>Maintain confidentiality of your login credentials</li>
              </ul>
            </section>

            <section className="mb-4">
              <h4 className="fw-semibold text-dark">5. Doctor Responsibilities</h4>
              <p className="text-muted">
                Doctors on this platform are licensed professionals responsible
                for delivering medical advice based on the information provided
                by users. The platform does not guarantee specific medical outcomes.
              </p>
            </section>

            <section className="mb-4">
              <h4 className="fw-semibold text-dark">6. Appointments & Payments</h4>
              <p className="text-muted">
                Appointment fees must be paid before consultation unless otherwise
                stated. Payments made are non-refundable once a consultation has
                been completed.
              </p>
              <p className="text-muted">
                The platform reserves the right to change consultation fees at
                any time.
              </p>
            </section>

            <section className="mb-4">
              <h4 className="fw-semibold text-dark">7. Privacy & Data Protection</h4>
              <p className="text-muted">
                We are committed to protecting your personal and medical data.
                All information is handled in accordance with our Privacy Policy
                and applicable data protection laws.
              </p>
            </section>

            <section className="mb-4">
              <h4 className="fw-semibold text-dark">8. Limitation of Liability</h4>
              <p className="text-muted">
                The platform shall not be liable for any direct, indirect,
                incidental, or consequential damages arising from the use or
                inability to use the service.
              </p>
            </section>

            <section className="mb-4">
              <h4 className="fw-semibold text-dark">9. Account Suspension</h4>
              <p className="text-muted">
                We reserve the right to suspend or terminate user accounts that
                violate these terms or misuse the platform.
              </p>
            </section>

            <section className="mb-4">
              <h4 className="fw-semibold text-dark">10. Modifications to Terms</h4>
              <p className="text-muted">
                These Terms and Conditions may be updated from time to time.
                Continued use of the platform indicates acceptance of any changes.
              </p>
            </section>

            <section>
              <h4 className="fw-semibold text-dark">11. Contact Information</h4>
              <p className="text-muted">
                If you have questions or concerns regarding these Terms and
                Conditions, please contact our support team through the platform.
              </p>
            </section>

          </div>
        </div>

        {/* Footer Note */}
        <div className="text-center mt-4 text-muted small">
        {/*   Last updated: {new Date().toLocaleDateString()} */}
        </div>
      </div>
    </div>

    <Footer/>

    </>
  );
};

export default TermsAndConditions;
